import { render, staticRenderFns } from "./NewSwitch.vue?vue&type=template&id=01c5e754&scoped=true"
import script from "./NewSwitch.vue?vue&type=script&lang=js"
export * from "./NewSwitch.vue?vue&type=script&lang=js"
import style0 from "./NewSwitch.vue?vue&type=style&index=0&id=01c5e754&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5e754",
  null
  
)

export default component.exports